import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

const client = axios.create({ baseURL: API });

export const api = {
  status: () => client.get("/status").then((r) => r.data),
  getConfig: () => client.get("/config").then((r) => r.data),
  updateConfig: (patch) => client.put("/config", patch).then((r) => r.data),
  kill: () => client.post("/engine/kill").then((r) => r.data),
  resume: () => client.post("/engine/resume").then((r) => r.data),
  reset: () => client.post("/engine/reset").then((r) => r.data),
  finalize: () => client.post("/engine/finalize").then((r) => r.data),
  exitPosition: (symbol) => client.post(`/position/${symbol}/exit`).then((r) => r.data),
  universe: () => client.get("/universe").then((r) => r.data),
  scanner: () => client.get("/scanner").then((r) => r.data),
  swing: () => client.get("/swing").then((r) => r.data),
  swingExit: (symbol) => client.post(`/swing/${symbol}/exit`).then((r) => r.data),
  swingSellDemat: (symbol) => client.post(`/swing/${symbol}/sell-demat`).then((r) => r.data),
  swingReleaseDemat: (symbol) => client.post(`/swing/${symbol}/release-demat`).then((r) => r.data),
  journal: (params) => client.get("/journal", { params }).then((r) => r.data),
  eod: () => client.get("/eod").then((r) => r.data),
  activity: () => client.get("/activity").then((r) => r.data),
  paperReport: () => client.get("/paper-report").then((r) => r.data),
  approve: (approved) => client.post("/paper-report/approve", { approved }).then((r) => r.data),
  backtest: (body) => client.post("/backtest", body).then((r) => r.data),
  backtestSweep: (body) => client.post("/backtest/sweep", body).then((r) => r.data),
  backtestSwing: (body) => client.post("/backtest/swing", body).then((r) => r.data),
  backtests: () => client.get("/backtests").then((r) => r.data),
  breakeven: (params) => client.get("/breakeven", { params }).then((r) => r.data),
  calendar: () => client.get("/calendar").then((r) => r.data),
  holiday: (date, action) => client.post("/calendar/holiday", { date, action }).then((r) => r.data),
  kiteStatus: () => client.get("/kite/status").then((r) => r.data),
  kiteDiagnostics: () => client.get("/kite/diagnostics").then((r) => r.data),
  kiteLogin: () => client.get("/kite/login").then((r) => r.data),
  kiteLogout: () => client.post("/kite/logout").then((r) => r.data),
};

export const fmtINR = (n, dp = 0) => {
  if (n === null || n === undefined) return "—";
  const sign = n < 0 ? "-" : "";
  const v = Math.abs(n).toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: dp });
  return `${sign}₹${v}`;
};

export const fmtPct = (n, dp = 2) => `${n >= 0 ? "+" : ""}${(n ?? 0).toFixed(dp)}%`;
